import { Link } from "react-router-dom";
import type {Product} from "../data/products"

type ProductCardProps = {
productSpecific: Product;
};

export default function ProductCard({productSpecific}:ProductCardProps) {
  const {slug, name, sku, images, short } = productSpecific;
  return (
    <>
      <div className="card">
        <Link to={`/produits/${slug}`}>
          <img
            src={images[0]}
            alt={name}
            style={{
              width: "100%",
              background: "rgba(255,255,255,0.06)",
              borderRadius: 12,
            }}
            aria-label={name}
          />
        </Link>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 10,
          }}
        >
          <div>
            <div style={{ fontWeight: 700 }}>{name}</div>
            <div className="small">SKU: {sku}</div>
          </div>
        </div>
        <p className="small" style={{ marginTop: 8 }}>
          {short}
        </p>
        <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
          <Link
            to={`/produits/${slug}`}
            className="btn"
            aria-label={`Voir ${name}`}
          >
            Voir le produit
          </Link>
        </div>
      </div>
    </>
  );
}
